import React from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';
import {
  withRouter,
} from 'react-router-dom';
import history from '../../navigation/history';
import BarcodeReader from 'react-barcode-reader';
import * as actions from '../../redux/actions';
import {
  PageHeader,
  Button,
  message,
  Modal
} from 'antd'
import BulkEdit from '../../components/ui/modals/BulkEdit';
import IncomingInventoryList from '../../components/ui/IncomingInventoryList';
import InventorySearchFilter from '../../components/ui/InventorySearchFilter';
import ProductSortBy from '../../constants/ProductSortBy';

import {
  DashboardContainer,
  PageTitle,
  FormCard,
  ScanButton
} from '../styles';


class Inventory extends React.Component {
  constructor(props) {
    super(props);
    const parsed = queryString.parse(this.props.location.search);
    const {
      consignerName,
      consignerId,
      productId
    } = parsed;
    if(productId) {
      this.props.getProduct(productId);
    }
    this.state = {
      id: null || productId,
      option1FixedValues: [],
      option1Switch: false,
      option2FixedValues: [],
      option2Switch: false,
      option3FixedValues: [],
      option3Switch: false,
      inventoryFilterVisible: false,
      filterOption1: null,
      filterOption2: null,
      filterOption3: null,
      filterLocationName: '',
      filterLocationId: null,
      filterLocationQuery: '',
      filterConsignerName: consignerName || '',
      filterConsignerId: consignerId || null,
      filterConsignerQuery: consignerName || '',
      productQuery: '',
      title: '',
      filterStatus: 'Active',
      filterShortCode: '',
      selectedInventory: [],
      bulkEditVisible: false,
      bulkEditKey: '',
      bulkEditKeyValue: '',
      filterReceivedAt: null,
      filterOrderDate: null,
      selectedSortBy: 0,
      filterTags: '',
      sortByOptions: [
        {
          label: 'Price (Low to High) and Consigner Priority',
          value: [['price', 'ASC'], ['isStoreInventory', 'ASC']]
        },
        {
          label: 'Price (Low to High)',
          value: [['price', 'ASC']]
        },
        {
          label: 'Consigner',
          value: [['consignerName', 'ASC']]
        },
        {
          label: 'Received At (Old to New)',
          value: [['receivedAt', 'ASC']]
        },
        {
          label: 'Received At (New to Old)',
          value: [['receivedAt', 'DESC']]
        },
        {
          label: 'Order Date (Old to New)',
          value: [['orderDate', 'ASC']]
        },
        {
          label: 'Order Date (New to Old)',
          value: [['orderDate', 'DESC']]
        }
      ]
    }
  }
  componentDidMount() {
    this.loadInventory();
    this.props.getProducts()
  }
  componentDidUpdate(oldProps) {
    //New Product Item
    const { productData } = this.props;
    const newProductItem = productData.productItem;
    //Old Product Item
    const oldProductItem = oldProps.productData.productItem;
    if(newProductItem) {
      if(oldProductItem !== newProductItem) {
        this.setState({
          ...newProductItem,
          locationQuery: newProductItem.locationName,
          consignerQuery: newProductItem.consignerName,
          productQuery: newProductItem.title
        })
      }
    }
  }
  handleInventoryFilter() {
    this.setState({
      inventoryFilterVisible: !this.state.inventoryFilterVisible
    })
  }
  handleBulkEdit() {
    this.setState({
      bulkEditVisible: !this.state.bulkEditVisible
    })
  }
  updateState(key, value) {
    if(key === 'id') {
      this.props.getProduct(value);
    }
    this.setState({
      [key]: value
    })
  }
  loadInventory() {
    const {
      filterOption1,
      filterOption2,
      filterOption3,
      filterLocationId,
      filterConsignerId,
      id,
      filterConsignerQuery,
      filterLocationQuery,
      filterStatus,
      filterShortCode,
      filterReceivedAt,
      filterOrderDate,
      selectedSortBy,
      filterTags,
      sortByOptions,
      isRemote,
      filterDateRange,
      filterDateRangeKey
    } = this.state;
    console.log(filterLocationQuery)
    const data = {
      productId: id,
      option1: filterOption1 !== '' ? filterOption1 : null,
      option2: filterOption2 !== '' ? filterOption2 : null,
      option3: filterOption3 !== '' ? filterOption3 : null,
      locationId: filterLocationQuery !== '' ? filterLocationId : null,
      consignerId: filterConsignerQuery !== '' ? filterConsignerId : null,
      status: 'Sold',
      shortCode: filterShortCode !== '' ? filterShortCode : null,
      receivedAt: filterReceivedAt !== '' ? filterReceivedAt : null,
      orderDate: filterOrderDate !== '' ? filterOrderDate : null,
      sortBy: selectedSortBy !== '' &&  sortByOptions[selectedSortBy] ? sortByOptions[selectedSortBy].value : null,
      tags: filterTags !== '' ? filterTags.split(',') : null,
      isRemote: true,
      remoteStatus: 'Pending',
      dateRangeKey: filterDateRangeKey !== '' ? filterDateRangeKey : null,
      dateRange: filterDateRange !== '' ? filterDateRange : null,

    }
    this.props.getInventoryForFilter(data);
    this.setState({ inventoryFilterVisible: false });
    console.log(data)
  }
  clearProduct() {
    this.setState({
      id: null,
      productQuery: '',
      title: '',
      option1: null,
      option2: null,
      option3: null,
      option1FixedValues: [],
      option1Switch: false,
      option2FixedValues: [],
      option2Switch: false,
      option3FixedValues: [],
      option3Switch: false,
      filterOption1: null,
      filterOption2: null,
      filterOption3: null,
    });
  }

  async acceptInventory(id, shortCode, ) {
    Modal.confirm({
      title: 'Confirm',
      content: 'Are sure you to accept this item?',
      onOk: async() => {
        const hide = message.loading(`Accepting item ${shortCode}`)
        await this.props.updateInventory({
          id,
          remoteStatus: 'Accept',
          remoteSaleAcceptedOn: moment()
        })
        await this.loadInventory()
        hide();
      },
      onCancel() {
        console.log('Cancel');
      },
    })
  }

  async declineInventory(id, shortCode) {
    Modal.confirm({
      title: 'Confirm',
      content: 'Are sure you want to decline the item?',
      onOk: async () => {
        const hide = message.loading(`Declining item ${shortCode}`)
        await this.props.updateInventory({ id, remoteStatus: 'Declined' })
        await this.props.sendRemoteSaleDeclined({ id })
        await this.loadInventory()
        hide();
      },
      okType: 'danger',
      okText: 'Decline',
      onCancel() {
        console.log('Cancel');
      },
    })
  }
  async searchProducts(value, callback) {
    await this.props.searchProducts(value, 1, ProductSortBy[0], false)
    const { searchProducts } = this.props.productData;
    return searchProducts.map(obj => {return {
      value: obj.id,
      label: obj.title
    }})
  }


  render() {
    const {
      filteredInventory,
      filteringInventory,
      updatingInventory
    } = this.props.inventoryData;
      return (
        <DashboardContainer id='container'>
          <PageHeader
            title={<PageTitle>Remote Sales</PageTitle>}
            breadcrumb={null}
            style={{ background: 'transparent' }}
          />
          <FormCard
          >
            <InventorySearchFilter
              updateState={(key, value) => this.updateState(key, value)}
              values={this.state}
              loadInventory={() => this.loadInventory()}
              query={this.state.filterLocationQuery}
              queryKey='filterLocationQuery'
              query2={this.state.filterConsignerQuery}
              queryKey2='filterConsignerQuery'
              query3={this.state.productQuery}
              queryKey3='productQuery'
              userId={this.props.auth.userData.id}
              canSelectProduct
              clearProduct={() => this.clearProduct()}
              disableStatus
              disableWithdrawalLocation
              userData={this.props.auth.userData}
              products={this.props.productData.searchProducts}
loadingProducts={this.props.productData.loadingSearchProducts}
onSearchProducts={(value) => this.searchProducts(value)}

            />
            <IncomingInventoryList
              userData={this.props.auth.userData}
              data={filteredInventory}
              loading={filteringInventory}
              updateState={(key, value) => this.updateState(key, value)}
              selectedInventory={this.state.selectedInventory}
              acceptInventory={(id, shortCode) => this.acceptInventory(id, shortCode)}
              declineInventory={(id, shortCode, item) => this.declineInventory(id, shortCode, item)}
              disableWithdrawalLocationName
              disableLocationName
              disablePayout
              disableOrderDateColumn
              disableOrderColumn
            />
          </FormCard>
          <BarcodeReader
            onScan={(data) => history.push(`inventory/${data}`)}
          />

        </DashboardContainer>
      );
  }
}
function mapStateToProps(state, props) {
    return {
        auth: state.AuthReducer,
        membership: state.MembershipReducer,
        inventoryData: state.InventoryReducer,
        productData: state.ProductReducer
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(actions, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Inventory));
